import styled from "styled-components";

export const Styled = styled.div`
    color: #bfbfbf
`;
